import React, { useState } from "react";
import { Box, Typography, Button, Chip } from "@mui/material";
import { AddCircleOutline, CheckCircle } from "@mui/icons-material";

const ExternalSongCard = ({ song, onRequestToAdd, requested }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleClick = async () => {
    if (requested || submitting) return;
    setSubmitting(true);
    try {
      await onRequestToAdd(song);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 2,
        p: 2,
        mb: 2,
        border: "1px solid",
        borderColor: isHovered ? "#666" : "#3c3c3c",
        backgroundColor: isHovered ? "#1a1a1a" : "#121212",
        borderRadius: "12px",
        transition: "all 0.2s ease-in-out",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, flex: 1, minWidth: 0 }}>
        {song.thumbnail ? (
          <Box
            component="img"
            src={song.thumbnail}
            alt={song.title}
            sx={{
              width: 56,
              height: 56,
              borderRadius: 1,
              objectFit: "cover",
              flexShrink: 0,
            }}
          />
        ) : (
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 1,
              bgcolor: "#333",
              flexShrink: 0,
            }}
          />
        )}
        <Box sx={{ minWidth: 0, width: "100%" }}>
          <Typography
            variant="subtitle1"
            sx={{
              color: "#fff",
              fontWeight: 600,
              lineHeight: 1.3,
              whiteSpace: "normal",
              overflowWrap: "anywhere",
            }}
          >
            {song.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.6)",
              whiteSpace: "normal",
              overflowWrap: "anywhere",
            }}
          >
            {song.artist}
          </Typography>
          <Chip
            label={song.source === "youtube" ? "YouTube" : "Spotify"}
            size="small"
            sx={{
              mt: 0.5,
              height: 20,
              fontSize: "0.65rem",
              bgcolor: "rgba(255,255,255,0.08)",
              color: "rgba(255,255,255,0.7)",
            }}
          />

          <Button
            variant="contained"
            size="small"
            disabled={requested || submitting}
            onClick={handleClick}
            startIcon={requested ? <CheckCircle /> : <AddCircleOutline />}
            sx={{
              mt: 1,
              mx: 2.5,
              flexShrink: 0,
              bgcolor: requested ? "#2e7d32" : "#1DB954",
              color: "#000",
              fontWeight: 600,
              textTransform: "none",
              "&:hover": { bgcolor: requested ? "#2e7d32" : "#1ed760" },
              "&.Mui-disabled": {
                bgcolor: requested ? "#2e7d32" : undefined,
                color: requested ? "#fff" : undefined,
              },
            }}
          >
            {requested ? "Requested" : submitting ? "..." : "Request To Add"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ExternalSongCard;
